
<table mdbtable responsive="true" *ngIf="!!this.BundleSet.Items">
  <tbody>
    <tr *ngFor="let p of this.BundleSet.Items">
      <td><img src="{{ getImageURL(p.ImageDataburst) }}" alt="" width="75" style="padding: 10px" /></td>
      <td>
        <small>{{ p.Description }}</small><br />
        <div>
          <!--<i class="fa fa-check text-success" *ngIf="p.StockingStatus === 'In Stock'"></i>-->
          <span *ngIf="p.FinalSale"
                class="badge red hand"
                triggers="hover"
                placement="top"
                container="body"
                style="color: white"
                mdbPopoverHeader="Special Order:"
                mdbPopover="Special Order items are ordered from the manufacturer and may take weeks to arrive. It requires a full, non-refundable payment.">
            Special order <i class="fas fa-info-circle"></i>
          </span>
          <small class="text-muted" *ngIf="!p.FinalSale"> {{ p.StockingStatus }}</small>
          <small class="text-muted" *ngIf="p.StockingStatus === 'In Stock'">-Ready to Ship</small>
        </div>
      </td>

      <td align="right">
        <small class="text-muted">Qty {{ p.Quantity }}</small>
      </td>
    </tr>
  </tbody>
</table>

<h6 class="d-flex justify-content-between align-items-center text-success">
  <strong><span class="">Bundle Price:</span></strong>
  <span class=""><strong>{{ this.BundleSet.Total | currency }}</strong></span>
</h6>
<hr />
